import React from "react";

export default function Loading() {
    return (
        <div className="loading-screen">
            <div className="loading-content">
                <div className="spinner" />
                <p className="loading-text">Chargement...</p>
            </div>
        </div>

    )
}